import React from "react";
import { reduxForm } from "redux-form";
import Button from "components/atoms/button/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";

import validate from "components/organisms/buyForm/validate.jsx";

import congratsIcon from "resources/img/buy-congrats-icon.svg";
import "containers/buy/styles.scss";

class ConfirmationForm extends React.Component {
  render() {
    const vehicle = this.props.vehicle;

    return (
      <form onSubmit={this.props.handleSubmit}>
        <div className="formText">
          <div className="iconCol">
            <img src={congratsIcon} alt="Felicitaciones" />
          </div>
          <div className="textCol">
            <h4>
              {" "}
              ¡Este {vehicle.brand} {vehicle.name} ya casi es tuyo!{" "}
            </h4>
            <p className="m">
              Confirma la reserva y solo te quedará realizar el pago online.
            </p>
            <p className="m">
              Recordá, una vez abonada la seña, tenés 48 horas para revisar y
              concretar la operación, y de no estar satisfecho se te reintegra
              el 100% del dinero.
            </p>
          </div>
        </div>

        <FormActions>
          <Button
            buttonText="Confirmar la reserva"
            type="submit"
            disabled={this.props.pristine || this.props.submitting}
          />
        </FormActions>
      </form>
    );
  }
}

export default reduxForm({
  form: "buy",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ConfirmationForm);
